import { useCurrentUser } from '../../contexts/UserContext';
import StudentInsightPanel from './StudentInsightPanel';
import TeacherInsightPanel from './TeacherInsightPanel';

export default function InsightPanel() {
  const currentUser = useCurrentUser();
  const isStudent = currentUser?.role === 'student';
  return isStudent ? <StudentInsightPanel /> : <TeacherInsightPanel />;
}
